module.exports = __webpack_public_path__ + "static/media/kids-baking-course-doodle.42ff8596.webp";